import type { SVGProps } from 'react';
const SvgIcecream = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#icecream_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m8.79 12.4 3.26 6.22 3.17-6.21c-.11-.08-.21-.16-.3-.25-.84.53-1.85.84-2.92.84-1.07 0-2.08-.31-2.92-.84-.09.09-.19.17-.29.24Zm-1.96.59A2.995 2.995 0 0 1 4 10a3 3 0 0 1 2.52-2.96A5.5 5.5 0 0 1 12 2a5.5 5.5 0 0 1 5.48 5.04A3 3 0 0 1 20 10c0 1.59-1.24 2.9-2.81 2.99L12.07 23 6.83 12.99Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="icecream_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIcecream;
